import { AMBER, NAVY, BORDER_COLOR, bubbleStyle } from '../../styles/tokens';

/**
 * Saldo de PTO en HORAS (V62). Antes eran DÍAS con total/usado/pendiente, leídos de
 * `pto_balances`; esa tabla se retiró y el saldo vive en `pto_balance_hours`, que se
 * consulta por `GET /api/vacation/availability`.
 *
 * ⚠ LAS TRES MAGNITUDES SON DISTINTAS Y NO SE PUEDEN COLAPSAR:
 *   balance   — lo acumulado por el motor desde las horas reales de Nómina
 *   reserved  — lo aprobado y todavía NO consumido (DERIVADO de las solicitudes, no
 *               almacenado: la aprobación reserva, no debita — V60)
 *   available — balance − reserved, y PUEDE SER NEGATIVO. No se pone piso en 0: los
 *               saldos negativos son válidos (V53) y esconder el sobregiro sería peor.
 *
 * ⚠ Es una ALERTA PARA QUIEN CARGA la solicitud, no información para el ausente: con 149
 * de 152 personas sin cuenta, el empleado no entra al portal. Por eso este componente vive
 * en el formulario y NO en el listado del empleado.
 */
const TIPOS = [
  { key: 'vacation', label: 'Vacaciones', color: '#2563eb' },
  { key: 'sick',     label: 'Enfermedad', color: '#dc2626' },
];

const fmt = (h) => `${(Number(h) || 0).toFixed(2)} h`;

export default function PTOBalanceCard({ availability, loading = false, personaName = null }) {
  if (loading) {
    return (
      <div style={{ ...bubbleStyle, padding: '16px 20px', marginBottom: 16, color: '#94a3b8', fontSize: 13 }}>
        Consultando saldo…
      </div>
    );
  }
  if (!availability) {
    return (
      <div style={{ ...bubbleStyle, padding: '16px 20px', marginBottom: 16, textAlign: 'center', color: '#94a3b8', fontSize: 13 }}>
        Elegí una persona para ver su saldo.
      </div>
    );
  }

  return (
    <div style={{ ...bubbleStyle, padding: '16px 20px', marginBottom: 16 }}>
      <div style={{ fontSize: 13, fontWeight: 700, color: NAVY, marginBottom: 12 }}>
        Saldo disponible{personaName ? ` — ${personaName}` : ''}
      </div>
      <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
        {TIPOS.map(t => {
          const d = availability[t.key] || { balance: 0, reserved: 0, available: 0 };
          const negativo = Number(d.available) < 0;
          return (
            <div key={t.key} style={{
              flex: '1 1 160px', minWidth: 160,
              background: '#f8fafc', borderRadius: 10,
              border: `1px solid ${negativo ? '#fecaca' : BORDER_COLOR}`, padding: '12px 14px',
            }}>
              <div style={{
                fontSize: 11, fontWeight: 600, color: t.color,
                textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: 6,
              }}>
                {t.label}
              </div>
              <div style={{ fontSize: 22, fontWeight: 700, color: negativo ? '#dc2626' : NAVY, lineHeight: 1 }}>
                {fmt(d.available)}
              </div>
              <div style={{ fontSize: 11, color: '#64748b', marginTop: 2 }}>disponibles</div>
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 10, color: '#94a3b8', marginTop: 8 }}>
                <span>Saldo: {fmt(d.balance)}</span>
                <span>Reservado: {fmt(d.reserved)}</span>
              </div>
            </div>
          );
        })}
      </div>
      <div style={{ fontSize: 10.5, color: '#94a3b8', marginTop: 10, lineHeight: 1.45 }}>
        «Reservado» son ausencias ya aprobadas cuyo mes todavía no cerró. El consumo real lo
        registra Nómina al cargar las horas.
      </div>
    </div>
  );
}
